import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import useMainStore from "../../../store/mainState";
import { useNavigate } from "react-router-dom";
import { ReactComponent as PlayIcon } from '../../../assets/icons/play.svg';
import { ReactComponent as LockIcon } from '../../../assets/icons/lock.svg';
import { isGameAvailableInUserCountry } from "../../../utils/gameAvailability";

export const GameItem = ({ game }: any) => {
    const navigate = useNavigate()
    const { user, setIsSignInOpen, mainContentWidth, activeSubItem, userCountry } = useMainStore();
    const [ratio, setRatio] = useState(6);
    const isAvailable = isGameAvailableInUserCountry(game, userCountry);

    const onPlayGame = (game: any) => {
        if (!user) {
            setIsSignInOpen(true);
            return;
        }
        navigate('/game', { state: { game } });
    }

    useEffect(() => {
        if (mainContentWidth > 1200) {
            setRatio(6);
        } else if (mainContentWidth > 900) {
            setRatio(5);
        } else if (mainContentWidth > 600) {
            setRatio(4);
        } else {
            setRatio(3);
        }
    }, [mainContentWidth]);

    return (
        <button
            key={game.id}
            className="group relative rounded-[12px] overflow-hidden m-[4px] flex-shrink-0 transition-all duration-300 ease-out hover:-translate-y-[4px] hover:shadow-[0_8px_30px_rgba(0,134,211,0.2)]"
            style={{
                width: `${(mainContentWidth) / ratio - 10}px`,
                height: `${((mainContentWidth) / ratio - 10) * (activeSubItem === 'LIVE' ? 1 : 1.1)}px`
            }}
            onClick={() => onPlayGame(game)}
        >
            {!isAvailable && <div className="w-full h-full absolute top-0 left-0 bg-black/50 rounded-[12px] flex justify-center items-center flex-col">
                <LockIcon width="32" height="32" fill="#fff" />
                <p className="text-white text-center text-[14px] font-semibold">Not available in your region</p>
            </div>}
            <img
                src={game.iconUrl}
                alt={game.name || "Game icon"}
                className="w-full h-full object-cover rounded-[12px]"
            />
            {/* Always-visible name overlay (bottom band) */}
            {isAvailable && (
                <div className="absolute bottom-0 left-0 right-0 flex items-end justify-center pt-[40px] pb-[10px] px-[8px] bg-gradient-to-t from-black/85 via-black/50 to-transparent rounded-b-[12px] pointer-events-none">
                    <p className="text-white text-center font-extrabold uppercase tracking-wide leading-tight drop-shadow-[0_2px_6px_rgba(0,0,0,0.7)] text-[clamp(11px,1.6vw,25px)] group-hover:text-[clamp(9px,1vw,14px)] transition-[font-size] duration-300 ease-out">
                        {game.name}
                    </p>
                </div>
            )}
            {/* Hover overlay */}
            <div className="absolute inset-0 flex flex-col items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 bg-black/40 rounded-[12px]">
                {isAvailable &&
                    <div className="w-[50px] h-[50px] rounded-full bg-white/20 backdrop-blur-sm border border-white/30 flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
                        <PlayIcon width="24" height="24" fill="#fff" />
                    </div>
                }
            </div>
        </button>
    )
}
